// extracted by mini-css-extract-plugin
export default {"editButton":"payRollUpload_editButton__veHdQ","TableBody":"payRollUpload_TableBody__JKnoT","deleteButton":"payRollUpload_deleteButton__bbwUz"};